import { ShoppingCart, User, LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { supabase } from '@/integrations/supabase/client';

interface HeaderProps {
  user: any;
  cartItemsCount: number;
  onCartClick: () => void;
  onAuthClick: () => void;
}

export const Header = ({ user, cartItemsCount, onCartClick, onAuthClick }: HeaderProps) => {
  const handleSignOut = async () => {
    await supabase.auth.signOut();
  };

  return (
    <header className="bg-white shadow-sm border-b">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-gradient-to-r from-primary to-primary/60 rounded-full"></div>
            <h1 className="text-xl font-bold text-primary">手工饰品</h1>
          </div>

          <nav className="hidden md:flex items-center space-x-8">
            <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
              首页
            </a>
            <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
              商品
            </a>
            <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
              关于我们
            </a>
            <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
              联系我们
            </a>
          </nav>

          <div className="flex items-center space-x-4">
            <Button
              variant="outline"
              size="sm"
              onClick={onCartClick}
              className="relative"
            >
              <ShoppingCart className="w-4 h-4" />
              {cartItemsCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-primary text-primary-foreground text-xs rounded-full w-5 h-5 flex items-center justify-center">
                  {cartItemsCount}
                </span>
              )}
            </Button>

            {user ? (
              <div className="flex items-center space-x-2">
                <span className="text-sm text-muted-foreground">
                  {user.email}
                </span>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={handleSignOut}
                >
                  <LogOut className="w-4 h-4" />
                </Button>
              </div>
            ) : (
              <Button
                variant="outline"
                size="sm"
                onClick={onAuthClick}
              >
                <User className="w-4 h-4 mr-2" />
                登录
              </Button>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};